import { useEffect } from 'react'
import { MainLayout } from './components/Layout/MainLayout'
import { Toaster } from "@/components/ui/toaster"
import { TooltipProvider } from "@/components/ui/tooltip"
import { ErrorBoundary } from './components/ErrorBoundary'
import { useDeviceStore } from './stores/device.store'

function App() {
  const autoConnect = useDeviceStore(state => state.autoConnect)

  useEffect(() => {
    autoConnect()
  }, [autoConnect])

  return (
    <ErrorBoundary>
      <TooltipProvider>
        <MainLayout />
        <Toaster />
      </TooltipProvider>
    </ErrorBoundary>
  )
}

export default App
